import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ChartItems } from '../charts-wrapper/charts.model';
import { TooltipDirective } from '../../../../ui-components/lib/tooltip/tooltip.directive';

@Component({
  selector: 'lib-charts-item',
  imports: [TooltipDirective],
  templateUrl: './chart-item.component.html',
  styleUrl: './chart-item.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ChartItemComponent {
  item = input.required<ChartItems>();
  itemDotClass = input.required<string>();
  showTooltip = input<boolean>(false);
}
